
import config from '@config';
import {
    xor as _xor,
    isEmpty as _isEmpty,
    orderBy as _orderBy,
} from '@lodash';
import Match from '@core/models/offer/Match';
import {
    IFavouriteItem,
    IUserPreferences,
    Getters,
    DEFAULT_USER_ID,
} from './types';

const getters : Getters = {
    tournaments(_state, getters, _rootState, rootGetters): IFavouriteItem[] {
        if (_isEmpty(rootGetters['data/sportOffer/events'])) {
            return [];
        }
        return getters._userState.favouriteTournaments
            .filter((id: number) => !!rootGetters['data/sportOffer/tournaments'][id])
            .map((id: number) => {
                const tournament = rootGetters['data/sportOffer/tournaments'][id];

                return {
                    id: tournament.id,
                    displayName: tournament.name,
                };
            });
    },
    tournamentsEvents(_state, getters, _rootState, rootGetters) {
        const events = rootGetters['data/sportOffer/events']
            .filter((event: Match) =>
                !!getters._userState.favouriteTournaments.find((id: number) => id === event.tournamentId)
                && !event.isFinished() && !event.isStopped());
        return _orderBy(events, config.app.sportOffer.eventGridSort);
    },
    tournamentIds(_state, getters) {
        return getters._userState.favouriteTournaments;
    },
    marketIds(_state, getters) {
        return getters._userState.favouriteMarkets;
    },
    _userState(state, getters): IUserPreferences {
        return state[getters._userId];
    },
    _userId(_state, _getters, _rootState, rootGetters) {
        const user = rootGetters['data/authentication/user'];
        return user ? user.userId : DEFAULT_USER_ID;
    },
    pinnedEventIds: (_state, getters) => {
        return getters._userState.pinnedEvents;
    },
    pinnedEvents: (_state, getters, _rootState, rootGetters) => {
        const events = rootGetters['data/sportOffer/eventsMap'];
        return getters.pinnedEventIds.map((id: number) => events[id]).filter((event) => !!event);
    },
};

export default getters;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/user/preferences/getters.ts